import { render, staticRenderFns } from "./Acttiv.vue?vue&type=template&id=40a199bc&scoped=true&"
import script from "./Acttiv.vue?vue&type=script&lang=js&"
export * from "./Acttiv.vue?vue&type=script&lang=js&"
import style0 from "./Acttiv.vue?vue&type=style&index=0&id=40a199bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a199bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VMain,VProgressCircular,VSheet})
